import { GET_ALL_PROVINCES, GetAllProvinces } from "../types/statics";

export const getAllProvinces = (payload: string): GetAllProvinces => {
  return { type: GET_ALL_PROVINCES, payload };
};
